import makeApiCall from "@packages/lib/server-actions/rest-api";
const searchFilterApiCall = async (path: string, body: any) => {
  return await makeApiCall({
    url: `${process.env.NEXT_PUBLIC_DOMSERVICE_API_DOMAIN}/${path}`,
    method: "POST",
    queryParams: {},
    body: body,
    headers: {
      "x-api-key": `${process.env.NEXT_PUBLIC_DOMSERVICE_X_API_KEY}`,
    },
  });
};

export { searchFilterApiCall };
